import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-angola-salesforce.component.scss';
var FormItemAngolaSalesforce = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemAngolaSalesforce, _super);
    function FormItemAngolaSalesforce(element) {
        return _super.call(this, element) || this;
    }
    FormItemAngolaSalesforce.prototype.init = function () {
        // this.form = this.element.querySelector('form') as HTMLFormElement;
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-submit__salesforce-form'));
    };
    FormItemAngolaSalesforce.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
                var element = event.target;
                var form = element.closest('form');
                var formFields = form.querySelectorAll('input, select');
                var validation = _this.validationService.validateEnterprise(formFields);
                if (validation.valid) {
                    _this.actionForm(form);
                }
            }); });
        }
    };
    FormItemAngolaSalesforce.prototype.actionForm = function (form) {
        // containers
        var hiddenInputs = Array.from(form.querySelectorAll('input[type=hidden'));
        var loader = form.querySelector('.form__loader--container');
        var thankyou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // other fields
        var reason = undefined;
        var name = form.querySelector('input[name=name]');
        var phone = form.querySelector('input[name=phone]');
        var email = form.querySelector('input[name=email]');
        var subjectField = form.querySelector('select[name=subject]');
        if (form.querySelector('input[name=reason]')) {
            reason = form.querySelector('input[name=reason]');
        }
        else {
            reason = form.querySelector('select[name=Reason]');
        }
        var sub = form.querySelector('select[name=Sub]');
        var comments = form.querySelector('textarea[name=description');
        var pageUrl = window.location.href;
        // DEV
        // let fields: any = {
        // 	name: name.value,
        // 	email: email.value,
        // 	phone: phone.value,
        // 	subject: subjectField.value,
        // 	description: `Reason:${reason.value}; Sub:${sub.value}; Comments:${comments.value};`,
        // 	'00N4K00000BIbCM': 'SVC_Angola_CCC',
        // }
        // SIT
        var fields = {
            name: name.value,
            email: email.value,
            phone: phone.value,
            subject: subjectField.value,
            description: "Reason:" + reason.value + "; Sub:" + sub.value + "; Comments:" + comments.value + ";",
            '00N4K00000BIbCM': 'SVC_Angola_CCC',
        };
        // Additional Variables
        fields.debug = 1;
        fields.orgid = '00D4K000001oOXx';
        fields.recordType = '0124K000000QAQUQA4';
        fields.debugEmail = 'salesforcesaplatformservices@standardbank.co.za';
        fields.external = 1;
        fields.Origin = 'Web';
        fields.retURL = window.location;
        var customHiddenIframeName = "JLA_API";
        if (!document.getElementById(customHiddenIframeName)) {
            var theiFrame = document.createElement("iframe");
            theiFrame.id = customHiddenIframeName;
            theiFrame.name = customHiddenIframeName;
            theiFrame.src = "about:blank";
            theiFrame.style.display = "none";
            document.body.appendChild(theiFrame);
        }
        var form = document.createElement("form");
        form.method = "POST";
        // DEV
        // form.action = "https://standardbankgroupltd--chnwvbdev.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        // SIT
        // form.action = "https://standardbankgroupltd--chnwsit.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        // UAT
        // form.action = "https://standardbankgroupltd--chnwuat.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        // PROD
        form.action = "https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8";
        form.setAttribute("target", customHiddenIframeName);
        for (var fieldName in fields) {
            var theInput = document.createElement("input");
            theInput.name = fieldName;
            theInput.value = fields[fieldName];
            theInput.setAttribute("type", "hidden");
            form.appendChild(theInput);
        }
        document.body.appendChild(form);
        form.submit();
        // analytics
        var analyticsService = new AnalyticsService();
        analyticsService.dtmFormComplete('complete', '');
        // service ok
        loader.classList.remove('active');
        thankyou.classList.add('active');
    };
    return FormItemAngolaSalesforce;
}(Base));
export { FormItemAngolaSalesforce };



//////////////////
// WEBPACK FOOTER
// ./components-angola/form-item-angola-salesforce/form-item-angola-salesforce.component.ts
// module id = 672
// module chunks = 0